module.exports = __webpack_public_path__ + "f90a2ad8bed9ee750a6297626d3b31f6.ttf";